import React, { Component } from 'react';
import { Dropdown, FormControl, Input, Button } from 'components';
import { DISCOUNT_TYPES, PERCENTAGE_ICON } from 'lib/globals';
import styles from 'styles/bundle.module.scss';
import { getIn } from 'immutable';
import classNames from 'lib/classNames';

const Bundle = ({ bundle, index, context, shopContext }) => {
	const { validationErrors } = context;
	const {state : { currency}} = shopContext
	const getError = (key) => getIn(validationErrors, ['settings.bundles.list', index, key], false);

	return (
		<div className={classNames('flex relative bg-white rounded p-3 pr-6 mb-4')}>
			<FormControl
				label="quantity"
				className={classNames('mr-2')}
				marginBottom="mb-0"
				error={!!getError('quantity')}
			>
				<Input
					type="number"
					BindToContext={[context, `settings.bundles.list.${index}.quantity`]}
					getError={!!getError('quantity')}
					specificValidation={'settings.bundles.list'}
					min="2"
					isFlex
					className={classNames('w-20')}
				/>
			</FormControl>
			<FormControl
				label="discount"
				className={classNames('flex-1 flex-grow')}
				marginBottom="mb-0"
				error={!!getError('reward')}
			>
				<Input
					type="number"
					BindToContext={[context, `settings.bundles.list.${index}.reward`]}
					getError={!!getError('reward')}
					specificValidation={'settings.bundles.list'}
					min="0"
					max="100"
					max={context.state.settings.bundles.list[index].type === 'percentage' ? 100 : undefined}
					withDropdown={{
						BindToContext: [context, `settings.bundles.list.${index}.type`],
						options: DISCOUNT_TYPES(currency),
						getError: !!getError('type'),
						specificValidation: 'settings.bundles.list',
					}}
					fullWidth
				/>
			</FormControl>
			<Button
				className={classNames('absolute top-1/2 right-0 -translate-y-1/2 transform translate-x-1/2')}
				icon="times"
				type="circle-danger"
				onClick={() => context.deleteBundle(bundle.id)}
			/>
		</div>
	);
};

export default Bundle;
